import url from './urls'

const state = {
  winners: null,
  isLoading: false
}

const mutations = {
  GET (state) {
    state.isLoading = true

    fetch(url.winners)
      .then(response => response.json())
      .then(data => {
        state.isLoading = false
        state.winners = data
      })
      .catch(err => {
        state.isLoading = false
        console.error(err)
      })
  }
}

const actions = {
  get ({ commit }) {
    commit('GET')
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
